import * as TypesCourseware from '../types/types_courseware';
import Vue from 'vue';

// 内容列表，依次是知识库、我的题目、上传题目
const ContentList = ['knowledgeDB', 'favorites', 'upload'];
export default {
    state: {
        coursewareDetail: null, // 讲义详情
        saved: false, // 讲义是否保存过
        coursewareDetailBakJson: 'null', // 讲义详情备份的json数据，用于通过对比现有详情确定修改状态
        currentContent: '', // 添加题目页面当前展示的内容(题目列表)
        knowledgeDB: { // 知识库/关联点
            knowledgeIds: [] // 知识点id数组
        },
        favorites: { // 我的题目
            favoritesId: '' // 收藏夹id
        },
        currentStage: '例题', // 添加讲义页面头部的类型，默认选择习题
        currentCategory: null, // 添加讲义页面头部的考法，默认选择第一个考法
        recommendQuestions: null, // 推荐题目
        toAddQuestionInTiKu: [], // 保存通过题库弹框要添加的题目
        addedQuestionInTiKu: [] // 保存点击确认添加按钮后，已经添加到课件中的题目，但是还没提交
    },
    getters: {
        CoursewareNeedsave: state => { // 讲义是否需要保存
            const isUnsaved = !state.saved; // 没有保存过
            const isChanged = JSON.stringify(state.coursewareDetail) !== state.coursewareDetailBakJson; // 被修改过
            return isUnsaved && isChanged;
        },
        CoursewareCategoriesRestQuestion: state => {
            const recommendQuestions = state.recommendQuestions;
            if (!recommendQuestions) {
                return {};
            }
            const coursewareDetail = state.coursewareDetail;
            const questionMap = {};
            coursewareDetail.withinLessonQuestions.forEach(item => { questionMap[item.id] = item; });
            coursewareDetail.practiceLessonQuestions.forEach(item => { questionMap[item.id] = item; });
            const categoriesMap = {};
            coursewareDetail.categories.forEach(item => {
                const categoryId = item.id.toString();
                categoriesMap[categoryId] = {
                    withinLessonQuestions: recommendQuestions.withinQuestions.filter(q => !questionMap[q.id] && q.categoryId.toString() === categoryId),
                    practiceLessonQuestions: recommendQuestions.practiceQuestions.filter(q => !questionMap[q.id] && q.categoryId.toString() === categoryId)
                };
            });
            return categoriesMap;
        }
    },
    mutations: {
        [TypesCourseware.COURSEWARE_SET_COURSEWARE_DETAIL](state, payload) {
            // 习题例题列表、讲法赋默认值
            if (payload) {
                const fixedCoursewareDetail = fixCoursewareDetail(payload);
                state.coursewareDetail = fixedCoursewareDetail;
                state.coursewareDetailBakJson = JSON.stringify(fixedCoursewareDetail);
                state.saved = false;
            } else { // 清空
                state.coursewareDetail = null;
                state.coursewareDetailBakJson = 'null';
                state.saved = false;
            }
        },
        [TypesCourseware.COURSEWARE_SET_CONTENT](state, {name, data, onlyData}) { // 布置作业左侧sidebar控制右侧展示的内容的通用方法
            /**
             * name:当前展示的内容的名字；
             * data:和内容名同名的对象，用于存放相关数据;
             * onlyData: 为true时只更新data不更新展示内容;
             */
            if (ContentList.includes(name)) {
                if (!onlyData) {
                    state.currentContent = name;
                }
                if (data) {
                    state[name] = data;
                }
            }
        },
        // 在线讲义增加题目页面头部修改类型
        [TypesCourseware.COURSEWARE_PUT_STAGE](state, payload) {
            state.currentStage = payload;
        },
        // 在线讲义增加题目页面头部修改考法
        [TypesCourseware.COURSEWARE_PUT_CATEGORY](state, payload) {
            state.currentCategory = payload;
        },
        // 讲义添加题目
        [TypesCourseware.COURSEWARE_ADD_QUESTION](state, payload) {
            if (payload.stage === '例题') { state.coursewareDetail.withinLessonQuestions.push(payload); }
            if (payload.stage === '习题') { state.coursewareDetail.practiceLessonQuestions.push(payload); }
        },
        // 讲义添加多个题目
        [TypesCourseware.COURSEWARE_ADD_QUESTIONS](state, {questionType, questions}) {
            console.log(questions);
            state.coursewareDetail[questionType].push(...questions);
        },
        // 讲义移除题目
        [TypesCourseware.COURSEWARE_REMOVE_QUESTION](state, payload) {
            if (payload.stage === '例题') {
                let index = state.coursewareDetail.withinLessonQuestions.findIndex(item => item.id === payload.id);
                state.coursewareDetail.withinLessonQuestions.splice(index, 1);
            } else {
                let index = state.coursewareDetail.practiceLessonQuestions.findIndex(item => item.id === payload.id);
                state.coursewareDetail.practiceLessonQuestions.splice(index, 1);
            }
        },
        // 获取推荐题目
        [TypesCourseware.COURSEWARE_SET_RECOMMEND_QUESTIONS](state, payload) {
            state.recommendQuestions = payload;
        },
        // 添加题库题目
        [TypesCourseware.COURSEWARE_ADD_QUESTION_TIKU](state, payload) { 
            state.toAddQuestionInTiKu.push(payload);
        },
        // 移除题库题目
        [TypesCourseware.COURSEWARE_REMOVE_QUESTION_TIKU](state, payload) { 
            let index = state.toAddQuestionInTiKu.findIndex(item => item.id === payload.id);
            if (index > -1) { 
                state.toAddQuestionInTiKu.splice(index, 1);
            }
        },
        // 删除已添加的题目根据id
        [TypesCourseware.COURSEWARE_REMOVE_QUESTION_BYID](state, id) { 
            let index = state.addedQuestionInTiKu.findIndex(item => item.id === id);
            if (index > -1) { 
                state.addedQuestionInTiKu.splice(index, 1);
                return true;
            }
            return false;
        },
        // 清空题库题目
        [TypesCourseware.COURSEWARE_CLEAR_QUESTION_TIKU](state, payload) { 
            state.toAddQuestionInTiKu.forEach(t => {
                t.hasAdd = false;
            });
            state.toAddQuestionInTiKu = [];
        },
        // 已经添加到课件中的题目, 将toAddQuestionInTiKu中的元素添加到addedQuestionsInTiKu
        [TypesCourseware.COURSEWARE_ADDED_QUESTION_TIKU](state, payload) { 
            state.toAddQuestionInTiKu.forEach(t => {
                state.addedQuestionInTiKu.push(t);
            });
        }
    },
    actions: {
        // 获取讲义详情
        [TypesCourseware.COURSEWARE_GET_COURSEWARE_DETAIL](ctx, coursewareId) {
            return Vue.http.get(`/v3/online-coursewares/${coursewareId}`).then(resp => {
                return Vue.checkResp(resp, {});
            }).then(data => {
                data.categories = data.knowledgePoints.reduce((arr, item) => arr.concat(item.categories), []);
                ctx.commit(TypesCourseware.COURSEWARE_SET_COURSEWARE_DETAIL, data);
                ctx.dispatch(TypesCourseware.COURSEWARE_GET_RECOMMEND_QUESTIONS);
                const firstCategory = data.categories[0];
                if (firstCategory) {
                    ctx.commit(TypesCourseware.COURSEWARE_PUT_CATEGORY, firstCategory);
                } else {
                    ctx.commit(TypesCourseware.COURSEWARE_PUT_CATEGORY, {name: '未关联考法', id: ''});
                }
                return data;
            });
        },
        // 保存讲义
        [TypesCourseware.COURSEWARE_SAVE_COURSEWARE](ctx) {
            // todo: data预处理
            const detail = ctx.state.coursewareDetail;
            const cmdQuestions = ctx.state.recommendQuestions;
            if (!detail) return;
            const withinLessonQuestions = formatQuestionForSubmit(detail.withinLessonQuestions);
            const practiceLessonQuestions = formatQuestionForSubmit(detail.practiceLessonQuestions);
            const params = {
                name: detail.name,
                difficulty: 'normal',
                isAutoRename: true,
                categories: detail.categories,
                withinLessonQuestions,
                practiceLessonQuestions
            };
            return Vue.http.put(`/v1/online-coursewares/${detail.id}`, params)
                .then(resp => Vue.checkResp(resp)).then(data => {
                    ctx.state.saved = true;
                    Vue.prototype.$message.success('保存成功');
                    ctx.dispatch(TypesCourseware.COURSEWARE_GET_COURSEWARE_DETAIL, detail.id);
                    cmdQuestions && window.lineTrack({ lineId: detail.timetableId ? 'courseware' : 'coursewareNo', pointType: 'E', topicExample: cmdQuestions.withinQuestions.length, topicExercises: cmdQuestions.practiceQuestions.length, useTopicExample: withinLessonQuestions.filter(v => cmdQuestions.withinQuestions.findIndex(n => v.id === n.id.toString()) > -1).length, useTopicExercises: practiceLessonQuestions.filter(v => cmdQuestions.practiceQuestions.findIndex(n => v.id === n.id.toString()) > -1).length });
                }).catch(err => {
                    Vue.prototype.$handleError(err);
                });
        },
        // 获取推荐题目
        [TypesCourseware.COURSEWARE_GET_RECOMMEND_QUESTIONS](ctx) {
            const coursewareDetail = ctx.state.coursewareDetail || {};
            const params = {
                subject: coursewareDetail.subject,
                selectedPeriod: parseInt(coursewareDetail.studyPhase / 10),
                studentId: coursewareDetail.studentId,
                knInfos: coursewareDetail.knowledgePoints.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        categories: item.categories.map(c => c.name)
                    };
                })
            };
            Vue.http.post('/v1/online-coursewares/courseware-questions', params)
                .then(resp => Vue.checkResp(resp))
                .then(data => {
                    ctx.commit(TypesCourseware.COURSEWARE_SET_RECOMMEND_QUESTIONS, data);
                });
        },
        // 添加推荐题目
        [TypesCourseware.COURSEWARE_ADD_RECOMMEND_QUESTIONS](ctx, {categoryId, questionType}) {
            // 计算应添加的题目数量
            let addQuestionNum = 3;
            const coursewareDetail = ctx.state.coursewareDetail || {};
            const rules = ctx.rootState.config.recommendQuestionConfig; // 推荐题目数量配置
            const rule = rules.find(item => {
                const samePeriod = item.period === parseInt(coursewareDetail.studyPhase / 10);
                const sameSubject = coursewareDetail.subject;
                return samePeriod && sameSubject;
            });
            if (rule) {
                const key = {withinLessonQuestions: 'exampleCount', practiceLessonQuestions: 'exerciseCount'}[questionType];
                addQuestionNum = rule[key];
            }
            const questions = ctx.getters.CoursewareCategoriesRestQuestion[categoryId][questionType]; // 去重后的可添加题目
            const newQuestions = questions.slice(0, addQuestionNum).map(item => {
                // 处理题目结构
                item.stage = {withinLessonQuestions: '例题', practiceLessonQuestions: '习题'}[questionType];
                item.fromType = item.type;
                item.yxComment = '';
                item.categoryId = '' + item.categoryId;
                return item;
            });
            ctx.commit(TypesCourseware.COURSEWARE_ADD_QUESTIONS, {
                questionType,
                questions: newQuestions
            });
        }
    }
};

function fixCoursewareDetail(detail) { // 处理获取到到讲义详情数据
    // 赋默认值
    detail.withinLessonQuestions = detail.withinLessonQuestions || [];
    detail.practiceLessonQuestions = detail.practiceLessonQuestions || [];
    // 处理旧数据中无考法的题目
    let needDefaultCategory = false;
    const defaultCategoryName = '未关联考法';
    detail.withinLessonQuestions.forEach(item => {
        if (!item.category) {
            item.category = defaultCategoryName;
            needDefaultCategory = true;
        }
        item.yxComment = item.yxComment || '';
    });
    detail.practiceLessonQuestions.forEach(item => {
        if (!item.category) {
            item.category = defaultCategoryName;
            needDefaultCategory = true;
        }
        item.yxComment = item.yxComment || '';
    });
    // const noDefaultCategory = !detail.categories.find(c => c.name === defaultCategoryName);
    // if (needDefaultCategory && noDefaultCategory) {
    //     detail.categories.push({
    //         key: Date.now() + detail.categories.length,
    //         name: defaultCategoryName
    //     });
    // }
    return detail;
}

function formatQuestionForSubmit(list) { // 将讲义详情的题目结构转为提交用的数据结构
    return list.map(item => {
        const params = {
            type: item.type,
            id: item.id,
            category: item.category,
            categoryId: item.categoryId,
            yxComment: item.yxComment
        };
        if (item.type === 3) {
            params.examId = item.hfsQuestion.examId;
            params.paperId = item.hfsQuestion.paperId;
            params.gradeAverageScore = item.hfsQuestion.gradeAverageScore;
            params.manfenRate = item.hfsQuestion.manfenRate;
        }
        return params;
    });
}



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_courseware.js